// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__PhioB","cards":"ClientCreditCards_cards__2fq00","empty":"ClientCreditCards_empty__2qNWr"};